import Model from '@/models/Model'

export default class SlCustomerAccountReceivable extends Model {
	static includes = [
		'sl_sale_debit_note',
		'sl_sale_invoice',
	]
	get number() {
		return this.sl_sale_invoice ? 
			this.sl_sale_invoice.number 
			: 
			this.sl_sale_debit_note ? 
				this.sl_sale_debit_note.number 
				: 
				'-'
	}
  resource() {
    return 'sl_customer_account_receivable'
  }
  toList() {
  	return this.include('sl_sale_invoice')
  }
}